// extracted by mini-css-extract-plugin
export var buttonsWrapper = "styles-module--buttonsWrapper--0bfad";
export var gradientWrapper = "styles-module--gradientWrapper--ead49";
export var title = "styles-module--title--15a9d";